import React from 'react';
import { ClipboardList, Activity, FileText, Shirt } from 'lucide-react';
import useInView from '../hooks/useInView';
import './FirstAppointmentSection.css';

const FirstAppointmentSection = () => {
  const { ref, isInView } = useInView();

  const steps = [
    {
      icon: <ClipboardList size={28} />,
      title: 'Anamnese',
      description: 'Ausführliches Gespräch über Ihre Beschwerden, Ziele, sportliche Aktivitäten und Ihren Alltag'
    },
    {
      icon: <Activity size={28} />,
      title: 'Befundung',
      description: 'Körperliche Untersuchung mit funktionellen Tests zur genauen Analyse'
    },
    {
      icon: <ClipboardList size={28} />,
      title: 'Therapieplanung',
      description: 'Individueller Behandlungsplan, erste Maßnahmen und Heimübungen'
    }
  ];

  const items = [
    {
      icon: <FileText size={20} />,
      text: 'Ärztliche Verordnung (bei medizinischen Beschwerden; Prävention ist auch ohne Verordnung möglich)'
    },
    {
      icon: <FileText size={20} />,
      text: 'Befunde (Arztbriefe, Bildgebung, MRT, Röntgen etc.)'
    },
    {
      icon: <Shirt size={20} />,
      text: 'Bequeme Sportsachen (z.B. Trainingskleidung)'
    },
    {
      icon: <FileText size={20} />,
      text: 'Handtuch'
    }
  ];

  return (
    <section
      id="ersttermin"
      className={`first-appointment-section reveal-section ${isInView ? 'is-visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <div className="section-header reveal-item" style={{ '--reveal-delay': '0ms' }}>
          <h2 className="heading-2">Ersttermin</h2>
          <p className="body-large section-subtitle">
            Was Sie beim ersten Termin erwartet
          </p>
        </div>
        <div className="appointment-content">
          <div className="appointment-steps reveal-item" style={{ '--reveal-delay': '100ms' }}>
            <h3 className="heading-3" style={{ marginBottom: 'var(--space-lg)' }}>Ablauf des Ersttermins</h3>
            <div className="steps-grid">
              {steps.map((step, index) => (
                <div key={index} className="step-card">
                  <div className="step-number">{index + 1}</div>
                  <div className="step-icon">{step.icon}</div>
                  <h4 className="body-large" style={{ fontWeight: 600, color: 'var(--primary-slate)' }}>
                    {step.title}
                  </h4>
                  <p className="body-medium">{step.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="appointment-checklist reveal-item" style={{ '--reveal-delay': '220ms' }}>
            <h3 className="heading-3" style={{ marginBottom: 'var(--space-lg)' }}>Bitte mitbringen</h3>
            <div className="checklist">
              {items.map((item, index) => (
                <div key={index} className="checklist-item">
                  <div className="checklist-icon">{item.icon}</div>
                  <p className="body-medium">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FirstAppointmentSection;